module.exports = __webpack_public_path__ + "static/img/submit.f663fc9d.png";